module.exports = __webpack_public_path__ + "petits_points.svg?a4819a0eea78ac493b3ad62f6cff3adf";


//////////////////
// WEBPACK FOOTER
// ./src/img/domaine_activite/petits_points.svg
// module id = 127
// module chunks = 0